import React, { PropsWithChildren } from "react";

import { HistoryPeopleSelect } from "./HistoryPeopleSelect";
import { OrganizerFilter } from "../../Context/Room/Overview/RoomInsightsContextProvider";

export const HistoryOrganizers = ({
  personalCalendarID,
  organizers,
  setOrganizers,
  handleClose,
}: PropsWithChildren<{
  personalCalendarID: string;
  organizers?: OrganizerFilter[];
  setOrganizers: React.Dispatch<
    React.SetStateAction<OrganizerFilter[] | undefined>
  >;
  handleClose: (() => void) | undefined;
}>) => {
  return (
    <HistoryPeopleSelect
      organizers={organizers}
      setOrganizers={setOrganizers}
      handleClose={handleClose}
      personalCalendarID={personalCalendarID}
    />
  );
};
